export const ecoStickerType: { [key: number]: string } = {
  1: 'zero',
  2: 'eco',
  3: 'C',
  4: 'B',
};

export enum ecoSticker {
  ZERO = 1,
  ECO = 2,
  C = 3,
  B = 4,
};
